<div class="d-flex" id="wrapper">

  <admin-sidebar id="admin-sidebar"></admin-sidebar>

  <div id="page-content-wrapper">

    <admin-navigation></admin-navigation>

    <div class="container-fluid">
      <div class="mt-5 mt-md-5 mb-3 mb-md-3">
        <h3 class="font-weight-bold page-title">Enterprises</h3>
      </div>
      <div class="row mb-4 mb-md-4">
        <div class="col-md-4 mb-3">
          <input type="text" class="form-control" placeholder="Search Enterprise" id="searchOrgInput">
        </div>
        <div class="col-md-2 mb-3">
          <select #type (change)="filterByType(type.value)" class="form-control">
            <option value="all">All</option>
            <option value="company">Company</option>
            <option value="school">School</option>
          </select>
        </div>
        <div class="col-md-4 offset-md-2">
          <button type="button" class="btn btn-primary pull-right add-button" data-toggle="modal" (click)="resetForm()"
                  data-target="#addOrganisation">Add Enterprise</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="font-weight-bold">Total: {{ totalRecords }}</p>
        </div>
      </div>
      <div class="alert alert-success alert-dismissible fade show mt-2" role="success" *ngIf="successOrgCreate">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        Enterprise successfully created.
      </div>
      <div class="alert alert-success alert-dismissible fade show mt-2" role="success" *ngIf="successOrgUpdate">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        Enterprise successfully updated.
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive">
          <table class="table table-borderless">
            <colgroup>
              <col width="25%">
              <col width="15%">
              <col width="20%">
              <col width="20%">
              <col width="20%">
            </colgroup>
            <thead>
            <tr>
              <th class="text-left">Name
                <!--
                <i class="fa fa-caret-down" *ngIf="sort_by == 'asc'" (click)="sort()"></i>
                <i class="fa fa-caret-up" *ngIf="sort_by == 'desc'" (click)="sort()"></i>
                -->
              </th>
              <th class="text-left">No. of Staff</th>
              <th class="text-left">Type</th>
              <th class="text-left">Domain</th>
              <th class="text-left">Created</th>
              <th class="text-left">Total Points</th>
              <th class="text-center">Status</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of organisations | paginate:{itemsPerPage: 25, currentPage:p}" routerLink='/admin/organisation-edit/{{item.id}}'>
              <td>{{item.name}}</td>
              <td class="text-left">{{item.users}}</td>
              <td class="text-left">{{item.type | titlecase }}</td>
              <td class="text-left">{{item.domains}}</td>
              <td>{{ item.created * 1000 | date:'dd/MM/yyyy':'+1200'}}</td>
              <td class="text-left">{{item.points}}</td>
              <td
                class="text-center"
                [ngClass]="{'text-success': item.status == 'Active', 'text-warning': item.status == 'Suspended'}"
              >
                {{item.status}}
              </td>
            </tr>
            <tr *ngIf="!loadingData && organisations?.length == 0 && processingSearch == 0">
              <td class="align-middle text-center" colspan="6">No Record Found</td>
            </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <nav *ngIf="!loadingData && organisations?.length > 0">
            <ul class="pagination justify-content-center">
              <li
                class="page-item"
                [ngClass]="{'disabled': currentPage == 1}"
                (click)="paginate(currentPage - 1)"
              >
                <a class="page-link" tabindex="-1">Previous</a>
              </li>
              <li
                class="page-item"
                *ngFor="let link of pageLinks"
                [ngClass]="{'active': currentPage == link}"
                (click)="paginate(link)"
              >
                <a class="page-link">{{ link }} <span class="sr-only" *ngIf="currentPage == link">(current)</span></a>
              </li>
              <li
                class="page-item"
                [ngClass]="{'disabled': currentPage == lastPage}"
                (click)="paginate(currentPage + 1)"
              >
                <a class="page-link">Next</a>
              </li>
            </ul>
          </nav>
          <!-- End of Pagination -->

        </div>
      </div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

    <!-- Add Modal -->
    <div class="modal fade" id="addOrganisation" tabindex="-1" role="dialog" aria-labelledby="addOrganisationLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="addOrganisationLabel">Add Enterprise</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="md-input">
              <input class="md-form-control"
                     required
                     type="text"
                     (keyup)="onKeyUpName()"
                     [(ngModel)]="enterpriseName"
                     [ngClass]="{'error': (submitted && this.enterpriseNameReqErr)}">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label>Name</label>
              <div *ngIf="nameAlreadyUsed" class="text-danger position-static">Enterprise name already used</div>
            </div>

            <div class="md-input">
              <select class="md-form-control enterprise-type"
                      (change)="onChangeType()"
                      [(ngModel)]="enterpriseType"
                      [ngClass]="{'error': (submitted && this.enterpriseTypeErr)}">
                <option value="company" selected>Company</option>
                <option value="school">School</option>
              </select>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label>Type</label>
              <span class="select-down-icon"><i class="fa fa-caret-down"></i></span>
            </div>

            <div class="my-5">
              <div *ngFor="let domain of domainRows; let i = index" class="md-input domain-row" style="margin:10px 0px;">
                <div>
                  <input class="md-form-control"
                         required
                         type="text"
                         [id]="'domainInput_' + i "
                         (keyup)="onKeyUpDomain(i)"
                         [(ngModel)]="domain.text"
                         [ngClass]="{'error': (submitted && this.domainReqErr && i == 0)}">
                  <a *ngIf="i != 0" class="select-down-icon cursor-pointer" (click)="deleteDomainRow(i)"><i class="fa fa-trash"></i></a>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label *ngIf="i == 0" >Domain</label>
                </div>
                <div [id]="'domainError_' + i " class="text-danger domain-errors position-static d-none"></div>
              </div>

              <div class="" style="margin:10px 0px 0px 0px;">
                <button type="button" class="badge module-button-white not-active mt-2" (click)="addDomainRow()">+ Add Domain</button>
              </div>
            </div>

            <div class="md-input">
              <input class="md-form-control"
                     required
                     type="number"
                     (keyup)="onKeyUpTotalUsers()"
                     [(ngModel)]="enterpriseTotalUsers"
                     [ngClass]="{'error': (submitted && this.enterpriseTotalUsersReqErr)}">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label>Company size</label>
            </div>

            <div>
              <div *ngFor="let freeTrial of freeTrialRows; let i = index" class="md-input freeTrial" style="margin:10px 0px;">
                <div>
                  <input class="md-form-control"
                         required
                         type="email"
                         [id]="'freeTrialInput_' + i "
                         (keyup)="onKeyUpFreeTrial(i)"
                         [(ngModel)]="freeTrial.text">
                  <a *ngIf="i != 0" class="select-down-icon cursor-pointer" (click)="deleteFreeTrialRow(i)"><i class="fa fa-trash"></i></a>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label *ngIf="i == 0" >Free Trial Users (Optional)</label>
                </div>
                <div [id]="'freeTrialError_' + i " class="text-danger freeTrial-errors position-static d-none"></div>
              </div>

              <div class="" style="margin:10px 0px 0px 0px;">
                <button type="button" class="badge module-button-white not-active mt-2" (click)="addFreeTrialRow()">+ Add Free Trial</button>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary btn-modal-save" (click)="createOrg()">Save
              <img src="../../../../assets/images/loader.gif" *ngIf="loading"></button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Add Modal -->

    <!-- Edit Modal -->
    <div class="modal fade" id="updateOrganisation" tabindex="-1" role="dialog" aria-labelledby="addOrganisationLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="editOrganisationLabel">Update Enterprise</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form [formGroup]="updateOrgForm" (ngSubmit)="updateOrg()">
            <div class="modal-body">
              <div class="md-input">
                <input class="md-form-control"
                       required
                       type="text"
                       formControlName="name"
                       [ngClass]="{'error': (submitted && updateOrgForm.invalid && uf.name.invalid) || (uf.name.dirty && uf.name.invalid)}"
                >
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Enterprise Name</label>
              </div>
              <div class="md-input">
                <input class="md-form-control"
                       required
                       type="text"
                       formControlName="domain"
                       [ngClass]="{'error': (submitted && updateOrgForm.invalid && uf.domain.invalid) || (uf.domain.dirty && uf.domain.invalid)}"
                >
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Domain</label>
              </div>
              <div class="md-input">
                <select id="cars" class="md-form-control" formControlName="status">
                  <option value="Active">Active</option>
                  <option value="Suspended">Suspended</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-modal-cancel" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary btn-modal-save">Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End of Add Modal -->

    <!-- loading modal -->
    <button type="button" class="btn btn-primary d-none" id="loader" data-toggle="modal" data-target="#loadingModal">Modal</button>
    <div class="modal fade" id="loadingModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="loadingLabel" aria-hidden="true">
      <div class="modal-dialog-centered modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close d-none" data-dismiss="modal" id="hideLoadingModal" aria-label="Close"></button>
          </div>
          <section class="h-100" id="loading">
            <header class="container h-100">
              <div class="d-flex align-items-center justify-content-center h-100">
                <div class="d-flex flex-column">
                  <img src="../../../../../assets/images/loader-big.svg">
                </div>
              </div>
            </header>
          </section>
          <div class="d-flex justify-content-center align-items-center">
            <label class="loading-label">Loading Organisations...</label>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
